export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/logo-small-8704a25f52be7ef961fcc325c38759d2.png";